(() => {
  'use strict';

  const autoOpen = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('notify') !== '1') return;
    const drawer = document.querySelector('back-in-stock-drawer');
    if (!drawer) return;
    const fire = () => {
      if (typeof drawer.show === 'function') drawer.show();
    };
    if (drawer.isConnected && drawer.shadowRoot !== undefined) {
      setTimeout(fire, 0);
    } else {
      requestAnimationFrame(fire);
    }
  };

  const bindForms = () => {
    document.querySelectorAll('form[data-back-in-stock-form]').forEach((form) => {
      if (form.dataset.boundBis === '1') return;
      form.dataset.boundBis = '1';
      form.addEventListener('submit', handleSubmit);
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const webhookUrl = form.dataset.webhookUrl;
    const countryCode = form.dataset.countryCode || '+91';
    const successAlert = form.querySelector('[data-bis-success]');
    const errorAlert = form.querySelector('[data-bis-error]');
    const submitBtn = form.querySelector('button[type="submit"]');

    if (successAlert) successAlert.setAttribute('hidden', '');
    if (errorAlert) errorAlert.setAttribute('hidden', '');

    const honeypotInput = form.querySelector('[name="honeypot"]');
    const honeypot = honeypotInput ? honeypotInput.value : '';
    if (honeypot.trim() !== '') {
      if (successAlert) successAlert.removeAttribute('hidden');
      form.reset();
      return;
    }

    if (!webhookUrl) {
      showError(errorAlert, form.dataset.errPost);
      return;
    }

    const nameInput = form.querySelector('[name="name"]');
    const phoneInput = form.querySelector('[name="phone"]');
    const name = nameInput ? nameInput.value.trim() : '';
    const phoneRaw = phoneInput ? phoneInput.value.trim() : '';

    if (name.length < 2) {
      showError(errorAlert, form.dataset.errInvalidName);
      return;
    }
    const phone = normalizePhone(phoneRaw, countryCode);
    if (!phone) {
      showError(errorAlert, form.dataset.errInvalidPhone);
      return;
    }

    if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');

    const payload = {
      name: name,
      phone: phone,
      product_id: form.dataset.productId || '',
      product_handle: form.dataset.productHandle || '',
      product_title: form.dataset.productTitle || '',
      variant_id: form.dataset.variantId || '',
      variant_title: form.dataset.variantTitle || '',
      shop_domain: form.dataset.shopDomain || '',
      source: 'storefront-theme',
      honeypot: ''
    };

    try {
      const res = await fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        credentials: 'omit',
        mode: 'cors'
      });
      if (!res.ok) throw new Error('http_' + res.status);
      if (successAlert) successAlert.removeAttribute('hidden');
      form.reset();
      setTimeout(() => {
        const drawer = form.closest('back-in-stock-drawer');
        if (drawer && typeof drawer.hide === 'function') drawer.hide();
      }, 3000);
    } catch (err) {
      showError(errorAlert, form.dataset.errPost);
      if (submitBtn) submitBtn.removeAttribute('disabled');
    }
  };

  const normalizePhone = (raw, countryCode) => {
    if (!raw) return null;
    const cc = countryCode.replace(/\D/g, '');
    const digits = raw.replace(/\D/g, '');
    if (raw.startsWith('+') && /^\+[1-9]\d{6,14}$/.test(raw)) return raw;
    if (cc && digits.length === cc.length + 10 && digits.startsWith(cc)) {
      return '+' + digits;
    }
    if (/^[6-9]\d{9}$/.test(digits)) return countryCode + digits;
    return null;
  };

  const showError = (el, msg) => {
    if (!el) return;
    el.textContent = msg || 'Something went wrong.';
    el.removeAttribute('hidden');
  };

  const init = () => {
    autoOpen();
    bindForms();
  };

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  document.addEventListener('shopify:section:load', bindForms);
})();
